import postMessageToParentExtension from '../utils/postMessageToParentExtension';
import { MessageRequestTypes } from '../schema/RequestMessageTypes';

export default function requestExtensionForDeviceGUID() {
    postMessageToParentExtension({
        type: MessageRequestTypes.GetDeviceGUID,
    });
}
